"use client";

import React from "react";
import Image from "next/image";
import { Divider } from "antd";

export default function HistoryItem({ history, index, length }) {
  const getDividerStyle = () => {
    if (index === 1) {
      return "pl-0";
    }
    if (index === length) {
      return "pr-0";
    }
    return " ";
  };

  const isEven = index % 2 === 0;

  return (
    <div className="flex flex-col relative z-[1] w-full rounded-md">
      <Image
        loading="lazy"
        src={history.thumbnail || "/images/default.jpg"}
        className={`h-[180px] w-[245px] object-cover self-center shadow-lg shadow-prim-70/30 rounded-md ${
          !isEven ? "md:order-last mt-[68px]" : "md:order-first mb-12 mx-[30px]"
        }`}
        alt={history.title || ""}
        width={400}
        height={288}
      />

      <div className={`md:block hidden relative ${getDividerStyle()}`}>
        <Divider className="history-divider bg-black min-w-full w-full" />
        <img
          src="/images/history_line.png"
          className="absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2"
          alt="/"
        />
      </div>
      <div
        className={`h-fit md:h-[180px] w-[245px] self-center text-center ${
          !isEven
            ? "md:order-first flex flex-col justify-end py-2 mb-12"
            : "md:order-last mt-[68px]"
        }`}
      >
        <div className="text-[#007AFF] text-3xl md:text-[60px] leading-[70px] font-semibold">
          {history.timeline}
        </div>
        <div className="text-base md:text-lg font-normal text-wrap">
          {history.content}
        </div>
      </div>
    </div>
  );
}
